import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import Dashboard from '../Dashboard';
import Tickets from '../Tickets';
import Carview from '../Carview';
import Header from '../Header';
import ChangePassword from '../ChangePassword';
import CarList from '../CarList';
import NotificationArea from '../NotificationArea';
import FleetManagers from '../FleetManagers';
import ServiceManagers from "../ServiceManagers";

class Page extends Component {
  render() {
    return (
      <div style={{ minHeight: '100%' }}>
        <Header />
        <Switch>
          <Redirect from="/" exact to="/dashboard" />
          <Route path="/tickets" component={Tickets} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/carview/:carId" component={Carview} />
          <Route path="/change-password" component={ChangePassword} />
          <Route path="/carlist" component={CarList} />
          <Route path="/reload" component={null} key="reload" />
          <Route path="/fleet-managers" component={FleetManagers} />
          <Route path="/service-managers" component={ServiceManagers} />
        </Switch>
        <NotificationArea />
      </div>
    );
  }
}

export default Page;
